/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
import { MenuItem } from '@blueprintjs/core';

export const filterItem = (query, facet, _index, exactMatch) => {
	const normalizedTitle = facet.toLowerCase();
	const normalizedQuery = query.toLowerCase();

	if (exactMatch) {
		return normalizedTitle === normalizedQuery;
	} else {
		return normalizedTitle.indexOf(normalizedQuery) >= 0;
	}
};

export const textItemRenderer = optionToString => (item, { handleClick, modifiers, index }) => {
	if (!modifiers.matchesPredicate) {
		return null;
	}
	return (
		<MenuItem
			key={index}
			active={modifiers.active}
			disabled={modifiers.disabled}
			onClick={handleClick}
			text={optionToString(item)}
		/>
	);
};

export const textItemFilterer = optionsToString => (query, rawFacet, _index, exactMatch) => {
	const facet = optionsToString(rawFacet);
	const normalizedTitle = facet.toLowerCase();
	const normalizedQuery = query.toLowerCase();

	if (exactMatch) {
		return normalizedTitle === normalizedQuery;
	} else {
		return normalizedTitle.indexOf(normalizedQuery) >= 0;
	}
};

export const textItemStyles = css`
  /* font-weight: bold; */
  .bp3-icon.bp3-icon-select:first-of-type {
    margin: 0;
  }
`;
